module.exports = __webpack_public_path__ + "img/paper-1.be92495b.png";